import { createProgress, type Progress } from "../../domain/progress/model/progress";
import type { ProgressRepository } from "../../domain/progress/progress-repository";

/**
 * localStorageが使用不可な環境（プライベートモード等）向けのフォールバック実装（F-008）。
 * インスタンス内のメモリにのみ保持するため、ページ再読み込みで失われるが、
 * 「そのセッション内は学習を継続できる」という受け入れ基準を満たす。
 */
export class InMemoryProgressRepository implements ProgressRepository {
  private progress: Progress = createProgress();

  load(): Progress {
    return this.progress;
  }

  save(progress: Progress): void {
    this.progress = progress;
  }

  clear(): void {
    this.progress = createProgress();
  }

  /** メモリ実装は破損データからの復旧という状態自体を持たないため常に`false`（E-7側で通知する）。 */
  hadRecoveryError(): boolean {
    return false;
  }
}
